export default "__VITE_ASSET__CZtJCe97__";